import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import { noop } from 'lodash';

import Checkbox from '~/components/ui/atoms/Checkbox';
import cn from '~/Utils/cn';

import { ErrorIcon } from '../../icons';

import colors from '../../../assets/colors.module.scss';

const disabledCardClassName = 'opacity-50 pointer-events-none';
const contentBaseClassName =
  // `[&&]` specificity boost is necessary to override default MUI last-child padding
  'cursor-pointer rounded-[inherit] border border-solid border-slate-500 bg-slate-100 hover:border-teal-700 [&&]:p-0';
const innerContainerClassName = 'py-[6px] pe-[18px] ps-2 flex items-center justify-between';

const CheckBanner = ({
  note,
  withIcon = false,
  withBold = false,
  onClick = noop,
  checked = undefined,
  disabled = false,
  cardClassName,
  wrapperClassNames,
  mutedWhenChecked = true,
}) => {
  const icon = withIcon ? <ErrorIcon size={20} iconColor={colors.textPrimary} /> : undefined;
  const cardClassNames = cn({ [disabledCardClassName]: disabled }, wrapperClassNames);
  const textClassNames = cn('flex items-center', { 'font-semibold': withBold });
  const checkboxClassName = cn({ 'text-slate-700': checked && mutedWhenChecked });
  const cardContentClassName = cn(contentBaseClassName, cardClassName);

  return (
    <Card className={cardClassNames} onClick={onClick}>
      <CardContent className={cardContentClassName}>
        <div className={innerContainerClassName}>
          <div className={textClassNames}>
            {/* The card's onClick receives the checkbox's click as it bubbles up. */}
            <Checkbox checked={checked} disabled={disabled} className={checkboxClassName} />
            {note}
          </div>
          {icon && <div className="flex items-center">{icon}</div>}
        </div>
      </CardContent>
    </Card>
  );
};

CheckBanner.propTypes = {
  note: PropTypes.string.isRequired,
  withIcon: PropTypes.bool,
  withBold: PropTypes.bool,
  onClick: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  cardClassName: PropTypes.string,
  wrapperClassNames: PropTypes.string,
  mutedWhenChecked: PropTypes.bool,
};

export default CheckBanner;
